(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-vpaidjs"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-vpaidjs"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/MggpVendorVPAIDJS.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/MggpVendorVPAIDJS.js":
/*!**********************************!*\
  !*** ./src/MggpVendorVPAIDJS.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by User on 21/04/2016.
 */

var MggpVendor = __webpack_require__(/*! mggp-player */ "mggp-player").Vendor;
var VPAIDWrapper = __webpack_require__(/*! ./VPAIDWrapper */ "./src/VPAIDWrapper.js");
var MggpVendorVPAIDJSConsts = __webpack_require__(/*! ./MggpVendorVPAIDJSConsts */ "./src/MggpVendorVPAIDJSConsts.js");

function MggpVendorVPAIDJS(player, config) {
	MggpVendor.apply(this, arguments);
	this._src = null;
	this._iframe = null;
	this._video = null;
	this._vpaidCreative = null;
	this._wrapper = null;
	this._adParameters = "{}";
	this._vastDocument = null;
	this._paused = false;
	this._started = false;
	this._stopped = false;
	this._volumeBeforeMute = .6;
	this._lastVolume = this._volumeBeforeMute;

	this.onTimeUpdate = this.onTimeUpdate.bind(this);

	this.emit('vendorCreate');
}

MggpVendorVPAIDJS.prototype = Object.create(MggpVendor.prototype);
MggpVendorVPAIDJS.prototype.constructor = MggpVendorVPAIDJS;

MggpVendorVPAIDJS.prototype.dispose = function () {
	if (this._video && this._video.parentNode) {
		this._video.parentNode.removeChild(this._video);

		if (this.player.config.singleVideoInstance) {
			this._video.style.display = 'none';
			this.container.appendChild(this._video);
		}
		this._video.src = '';
	}

	if (!this._stopped && this._wrapper) {
		this.stop();
	}
	if (this._iframe && this._iframe.parentNode) {
		this._iframe.parentNode.removeChild(this._iframe);
	}

	this._wrapper = null;

	this.emit('vendorDestroy');
};

MggpVendorVPAIDJS.prototype.toggleEvents = function (pOn) {
	if (pOn) {
		this.player.on("player:timeUpdate", this.onTimeUpdate);
	} else {
		this.player.off("player:timeUpdate", this.onTimeUpdate);
	}
};

MggpVendorVPAIDJS.prototype.onWindowResize = function () {
	var width, height;
	if (this.player.config && this.player.config.container) {
		width = this.player.config.container.offsetWidth;
		height = this.player.config.container.offsetHeight;
	} else {
		width = 690;
		height = 390;
	}

	if (this._wrapper) this._wrapper.resizeAd(width, height, 'normal');
};

MggpVendorVPAIDJS.prototype.onTimeUpdate = function () {
	if (this._wrapper && !this._stopped) {
		this.onWindowResize();
		if (this._wrapper.getAdDuration()) {
			var duration = this._wrapper.getAdDuration();
			var position = this._wrapper.getAdRemainingTime();
			if (duration > 0 && position > 0) {
				this.set('duration', duration);
				this.set('position', duration - this._wrapper.getAdRemainingTime());
			}
		}
	}
};

MggpVendorVPAIDJS.prototype.load = function (src, videoInfo, options) {
	this._src = src;
	this.checkOptions(options);
	this._setState(-1);
	if (options['adParameters']) {
		this._adParameters = options['adParameters'];
	}
	if (options['vastDocument']) {
		this._vastDocument = options['vastDocument'];
	}
	this._createIframe();
};

MggpVendorVPAIDJS.prototype.play = function () {
	if (this._wrapper) {
		this._paused = false;
		if (!this._started) {
			this._wrapper.startAd();
		} else {
			this._wrapper.resumeAd();
		}
	}
};

MggpVendorVPAIDJS.prototype.pause = function () {
	if (this._wrapper) {
		this._paused = true;
		this._wrapper.pauseAd();
	}
};

MggpVendorVPAIDJS.prototype.stop = function () {
	this.toggleEvents(false);

	if (this._wrapper) {
		this._paused = false;
		this._stopped = true;
		this._wrapper.stopAd();
	}
	this.dispose();
};

MggpVendorVPAIDJS.prototype.togglePlayPause = function () {
	if (this._wrapper) {
		if (this._paused) {
			this._wrapper.resumeAd();
		} else {
			this._wrapper.pauseAd();
		}
		this._paused = !this._paused;
	}
};

MggpVendorVPAIDJS.prototype.setVolume = function (volume) {
	if (volume > 100) {
		volume = 100;
	} else if (volume < 0) {
		volume = 0;
	}
	if (this._wrapper) {
		this._volumeBeforeMute = volume / 100;

		if (volume > 0) {
			if (this.get('muted')) {
				this.unMute();
			}
		} else {
			this.set('muted', true);
		}

		this._wrapper.setAdVolume(this._volumeBeforeMute);
		this.set('volume', volume);
	}
};

MggpVendorVPAIDJS.prototype.mute = function () {
	if (this._wrapper) {
		this._wrapper.setAdVolume(0);
		this.set('volume', 0);
		this.set('muted', true);
	}
};

MggpVendorVPAIDJS.prototype.unMute = function () {
	if (this._wrapper) {
		this._volumeBeforeMute = this._volumeBeforeMute || .6;
		this._wrapper.setAdVolume(this._volumeBeforeMute);
		this.set('volume', this._volumeBeforeMute * 100);
		this.set('muted', false);
	}
};

//privates
MggpVendorVPAIDJS.prototype._setState = function (newState) {
	this.set('state', newState);
	this.emit('stateChange', newState);
};

MggpVendorVPAIDJS.prototype._trackEvent = function (event) {
	if (this._vastDocument && typeof this._vastDocument[event] === 'function') {
		this._vastDocument[event]();
	}
};

MggpVendorVPAIDJS.prototype._wrapperCallback = function (key, data) {
	switch (key) {
		case MggpVendorVPAIDJSConsts.AdStarted:
			this._started = true;
			this._setState(1);
			this._trackEvent('creativeView');
			window.addEventListener('resize', this.onWindowResize.bind(this));
			break;
		case MggpVendorVPAIDJSConsts.AdStopped:
			this._setState(0);
			this._trackEvent('stop');
			this.toggleEvents(false);
			window.removeEventListener('resize', this.onWindowResize);
			break;
		case MggpVendorVPAIDJSConsts.AdSkipped:
			this._setState(0);
			this._trackEvent('skip');
			this.toggleEvents(false);
			break;
		case MggpVendorVPAIDJSConsts.AdLoaded:
			if (this._wrapper) {
				this.toggleEvents(true);
				this._wrapper.startAd();
			}
			break;
		case MggpVendorVPAIDJSConsts.AdLinearChange:

			break;
		case MggpVendorVPAIDJSConsts.AdSizeChange:

			break;
		case MggpVendorVPAIDJSConsts.AdExpandedChange:

			break;
		case MggpVendorVPAIDJSConsts.AdSkippableStateChange:

			break;
		case MggpVendorVPAIDJSConsts.AdDurationChange:
			this.set('duration', data);
			break;
		case MggpVendorVPAIDJSConsts.AdRemainingTimeChange:
			var duration = this.get('duration');
			if (!duration) {
				duration = data;
				this.set('duration', data);
			}
			this.set('position', duration - data);
			break;
		case MggpVendorVPAIDJSConsts.AdVolumeChange:
			var volume = this._wrapper.getAdVolume();
			if (volume === 0 && this._lastVolume > 0) {
				this._trackEvent('mute');
			} else if (volume > 0 && this._lastVolume === 0) {
				this._trackEvent('unmute');
			}
			this._lastVolume = volume;
			this.set('volume', volume);
			this.set('muted', volume === 0);
			break;
		case MggpVendorVPAIDJSConsts.AdImpression:
			this._trackEvent('impression');
			break;
		case MggpVendorVPAIDJSConsts.AdClickThru:
			this._trackEvent('click');
			//https://www.iab.com/wp-content/uploads/2015/06/VPAID_2_0_Final_04-10-2012.pdf (2.5.4)

			/*If event.data.playerHandles is false, then the video player doesn’t open
   the landing page URL. The ad unit is responsible for opening the landing page URL in
      a new window in this case.*/

			if (data.playerHandles) {
				var wind;
				if (data.url && typeof data.url === 'string') {
					// video player must use event.data.url
					wind = window.open(data.url, '_blank');
				} else if (this._vastDocument && this._vastDocument.vastData) {
					// the video player must use the VAST element, VideoClicks/ClickThrough
					var clickthroughArray = this._vastDocument.vastData['clickthrough'];
					if (clickthroughArray.length && clickthroughArray[0].length) {
						wind = window.open(clickthroughArray[0], '_blank');
					}
				}
				if (wind) wind.focus();
			}

			this._wrapper.pauseAd();
			this.player.emit('ad:skin:clickOnBg');
			break;
		case MggpVendorVPAIDJSConsts.AdInteraction:

			break;
		case MggpVendorVPAIDJSConsts.AdVideoStart:
			this._trackEvent('start');
			break;
		case MggpVendorVPAIDJSConsts.AdVideoFirstQuartile:
			this._trackEvent('firstQuartile');
			break;
		case MggpVendorVPAIDJSConsts.AdVideoMidpoint:
			this._trackEvent('midpoint');
			break;
		case MggpVendorVPAIDJSConsts.AdVideoThirdQuartile:
			this._trackEvent('thirdQuartile');
			break;
		case MggpVendorVPAIDJSConsts.AdVideoComplete:
			this._trackEvent('complete');
			break;
		case MggpVendorVPAIDJSConsts.AdUserAcceptInvitation:
			this._trackEvent('acceptInvitation');
			break;
		case MggpVendorVPAIDJSConsts.AdUserMinimize:
			this._trackEvent('collapse');
			break;
		case MggpVendorVPAIDJSConsts.AdUserClose:
			this._setState(0);
			this._trackEvent('close');
			this.toggleEvents(false);
			break;
		case MggpVendorVPAIDJSConsts.AdPaused:
			this._setState(2);
			this._trackEvent('pause');
			break;
		case MggpVendorVPAIDJSConsts.AdPlaying:
			this._setState(1);
			this._trackEvent('resume');
			break;
		case MggpVendorVPAIDJSConsts.AdError:
			this._setState(0);
			this.emit('mediaError');
			break;
		case MggpVendorVPAIDJSConsts.AdLog:

			break;
		case MggpVendorVPAIDJSConsts.ERROR:
			this.dispose();
			break;
		case MggpVendorVPAIDJSConsts.REMOVE_CREATIVE_AND_STAY_ON_PAUSE:
			this._stopped = true;
			this.dispose();
			break;
	}
};

MggpVendorVPAIDJS.prototype._createIframe = function () {
	if (this.player.config.singleVideoInstance) {
		var instances = this.player.get('videoInstances');
		this._video = instances[0].className === "ad:vendor:video" ? instances[0] : instances[1];
	} else {
		this._video = document.createElement('video');
		this._video.style.position = 'absolute';
		this.container.appendChild(this._video);
	}

	this._video.style.width = '100%';
	this._video.style.height = '100%';
	this._video.style.display = 'inline-block';
	this._video.removeAttribute('controls');

	var iframeTemplate = '<!DOCTYPE html><html><head><script type="text/javascript" src="%vpaidScript%"></script></head><body style="margin: 0px; padding: 0px; width: %width%; height: %height%"><script type="text/javascript">window.parent.postMessage(\'{"event": "ready", "iframeID": "%iframeID%"}\', "%origin%");</script></body></html>';
	this._iframe = document.createElement('iframe');
	this._iframe.style.border = 'none';
	this._iframe.frameborder = '0';
	this._iframe.scrolling = 'no';
	this._iframe.style.position = 'absolute';
	this._iframe.style.overflow = 'hidden';
	this._iframe.style.width = '100%';
	this._iframe.style.height = '100%';
	this._iframe.style.backgroundColor = 'initial';
	this._iframe.id = 'mggVPAIDIframe';
	this._iframe.setAttribute("data-adl-consent", "ignore");
	this.container.appendChild(this._iframe);

	var self = this;

	window.addEventListener('message', onMessageFromVPAIDIframe);

	var iframeDoc = this._iframe.contentWindow && this._iframe.contentWindow.document;
	var origin = getOrigin();
	var template = iframeTemplate.replace('%vpaidScript%', this._src).replace('%iframeID%', this._iframe.id).replace('%origin%', origin);
	template = template.replace('%width%', this.player.config.container.offsetWidth + 'px').replace('%height%', this.player.config.container.offsetHeight + 'px');
	iframeDoc.write(template);
	// MHP-1045: Аналитика Adloox делает init по document.ready но он никогда не наступает ибо мы не закрыли документ
	iframeDoc.close();

	function onMessageFromVPAIDIframe(event) {
		var origin = getOrigin();
		if (event.origin === origin && event.data) {
			var data = JSON.parse(event.data);
			if (data && data.iframeID === self._iframe.id) {
				window.removeEventListener('message', onMessageFromVPAIDIframe);
				processVPAID();
			}
		}
	}

	function getOrigin() {
		if (window.location.origin) {
			return window.location.origin;
		} else {
			return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
		}
	}

	function processVPAID() {
		var getVPAIDFunc = self._iframe.contentWindow['getVPAIDAd'];
		if (getVPAIDFunc && typeof getVPAIDFunc === 'function') {
			self._vpaidCreative = getVPAIDFunc();
		}
		var width, height;
		if (self.player.config && self.player.config.container) {
			width = self.player.config.container.offsetWidth;
			height = self.player.config.container.offsetHeight;
		} else {
			width = 690;
			height = 390;
		}
		var wrapperOptions = {
			mainCallback: self._wrapperCallback.bind(self),
			logFunction: self.log.bind(self),
			player: self.player
		};
		self._wrapper = new VPAIDWrapper(self._vpaidCreative, wrapperOptions);
		// var video = self._iframe.contentWindow.document.getElementById('vpaidVideo');

		if (self._iframe && self._iframe.contentWindow) {
			self._wrapper.initAd(width, height, 'normal', 720, { 'AdParameters': self._adParameters }, {
				slot: self._iframe.contentWindow.document.body,
				videoSlot: self._video,
				videoSlotCanAutoPlay: true
			});
		}
	}
};

MggpVendorVPAIDJS.mimeTypes = ['js'];
MggpVendorVPAIDJS.priority = 0;
MggpVendorVPAIDJS.canPlay = function (type) {
	return MggpVendorVPAIDJS.mimeTypes.indexOf(type) != -1;
};
module.exports = MggpVendorVPAIDJS;

/***/ }),

/***/ "./src/MggpVendorVPAIDJSConsts.js":
/*!****************************************!*\
  !*** ./src/MggpVendorVPAIDJSConsts.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by User on 21/04/2016.
 */
module.exports = {
	AdStarted: 'adStarted',
	AdStopped: 'adStopped',
	AdSkipped: 'adSkipped',
	AdLoaded: 'adLoaded',
	AdLinearChange: 'adLinearChange',
	AdSizeChange: 'adSizeChange',
	AdExpandedChange: 'adExpandedChange',
	AdSkippableStateChange: 'adSkippableStateChange',
	AdDurationChange: 'adDurationChange',
	AdRemainingTimeChange: 'adRemainingChange',
	AdVolumeChange: 'adVolumeChange',
	AdImpression: 'adImpression',
	AdClickThru: 'adClickThru',
	AdInteraction: 'adInteraction',
	AdVideoStart: 'adVideoStart',
	AdVideoFirstQuartile: 'adVideoFirstQuartile',
	AdVideoMidpoint: 'adVideoMidpoint',
	AdVideoThirdQuartile: 'adVideoThirdQuartile',
	AdVideoComplete: 'adVideoComplete',
	AdUserAcceptInvitation: 'adUserAcceptInvitation',
	AdUserMinimize: 'adUserMinimize',
	AdUserClose: 'adUserClose',
	AdPaused: 'adPaused',
	AdPlaying: 'adPlaying',
	AdError: 'adError',
	AdLog: 'adLog',

	ERROR: 'error',

	REMOVE_CREATIVE_AND_STAY_ON_PAUSE: 'removeCreativeAndStayOnPause'
};

/***/ }),

/***/ "./src/VPAIDWrapper.js":
/*!*****************************!*\
  !*** ./src/VPAIDWrapper.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by User on 21/04/2016.
 */

var MggpVendorVPAIDJSConsts = __webpack_require__(/*! ./MggpVendorVPAIDJSConsts */ "./src/MggpVendorVPAIDJSConsts.js");

// This class is meant to be part of the video player that interacts with the Ad.
// It takes the VPAID creative as a parameter in it's contructor.
function VPAIDWrapper(VPAIDCreative, options) {
	this._creative = VPAIDCreative;
	//this._envVars = {
	//	slot: options.iframe
	//};
	this._pausedAfterClick = false;
	this._paused = false;
	this._stopped = false;

	this._mainCallback = options.mainCallback;
	this._logFunc = options.logFunction;
	this._player = options.player;
	//this._adParameters = options.adParameters;


	if (!this.checkVPAIDInterface(VPAIDCreative)) {
		//The VPAIDCreative doesn't conform to the VPAID spec
		this._mainCallback(MggpVendorVPAIDJSConsts.AdError);
		return;
	}
	this.setCallbacksForCreative();
}

VPAIDWrapper.prototype.checkVPAIDInterface = function (VPAIDCreative) {
	var result = false;
	if (VPAIDCreative && VPAIDCreative.handshakeVersion && typeof VPAIDCreative.handshakeVersion === "function" && VPAIDCreative.initAd && typeof VPAIDCreative.initAd === "function" && VPAIDCreative.startAd && typeof VPAIDCreative.startAd === "function" && VPAIDCreative.stopAd && typeof VPAIDCreative.stopAd === "function" && VPAIDCreative.skipAd && typeof VPAIDCreative.skipAd === "function" && VPAIDCreative.resizeAd && typeof VPAIDCreative.resizeAd === "function" && VPAIDCreative.pauseAd && typeof VPAIDCreative.pauseAd === "function" && VPAIDCreative.resumeAd && typeof VPAIDCreative.resumeAd === "function" && VPAIDCreative.expandAd && typeof VPAIDCreative.expandAd === "function" && VPAIDCreative.collapseAd && typeof VPAIDCreative.collapseAd === "function" && VPAIDCreative.subscribe && typeof VPAIDCreative.subscribe === "function" && VPAIDCreative.unsubscribe && typeof VPAIDCreative.unsubscribe === "function") {
		result = true;
	}
	return result;
};

// This function registers the callbacks of each of the events
VPAIDWrapper.prototype.setCallbacksForCreative = function () {

	//The key of the object is the event name and the value is a reference to the
	//callback function that is registered with the creative
	var callbacks = {
		AdStarted: this.onStartAd,
		AdStopped: this.onStopAd,
		AdSkipped: this.onSkipAd,
		AdLoaded: this.onAdLoaded,
		AdLinearChange: this.onAdLinearChange,
		AdSizeChange: this.onAdSizeChange,
		AdExpandedChange: this.onAdExpandedChange,
		AdSkippableStateChange: this.onAdSkippableStateChange,
		AdDurationChange: this.onAdDurationChange,
		AdRemainingTimeChange: this.onAdRemainingTimeChange,
		AdVolumeChange: this.onAdVolumeChange,
		AdImpression: this.onAdImpression,
		AdClickThru: this.onAdClickThru,
		AdInteraction: this.onAdInteraction,
		AdVideoStart: this.onAdVideoStart,
		AdVideoFirstQuartile: this.onAdVideoFirstQuartile,
		AdVideoMidpoint: this.onAdVideoMidpoint,
		AdVideoThirdQuartile: this.onAdVideoThirdQuartile,
		AdVideoComplete: this.onAdVideoComplete,
		AdUserAcceptInvitation: this.onAdUserAcceptInvitation,
		AdUserMinimize: this.onAdUserMinimize,
		AdUserClose: this.onAdUserClose,
		AdPaused: this.onAdPaused,
		AdPlaying: this.onAdPlaying,
		AdError: this.onAdError,
		AdLog: this.onAdLog
	};
	// Looping through the object and registering each of the callbacks with the
	//creative
	for (var eventName in callbacks) {
		this._creative.subscribe(callbacks[eventName], eventName, this);
	}
};

// Pass through for initAd - when the video player wants to call the ad
VPAIDWrapper.prototype.initAd = function (width, height, viewMode, desiredBitrate, creativeData, environmentVars) {
	this._creative.initAd(width, height, viewMode, desiredBitrate, creativeData, environmentVars);
};
// Pass through for getAdLinear
VPAIDWrapper.prototype.getAdLinear = function () {
	this._logFunc("getAdLinear");
	return this._creative.getAdLinear();
};
// Pass through for startAd()
VPAIDWrapper.prototype.startAd = function () {
	this._logFunc("startAd");
	this._creative.startAd();
};
//Pass through for stopAd()
VPAIDWrapper.prototype.stopAd = function () {
	try {
		//IN-3616: EU Broken VAST in problem VPAID advertising
		this._creative.stopAd();
	} catch (e) {}

	this._mainCallback = function () {};
};
//Passthrough for setAdVolume
VPAIDWrapper.prototype.setAdVolume = function (val) {
	this._creative.setAdVolume(val);
};
//Passthrough for getAdVolume
VPAIDWrapper.prototype.getAdVolume = function () {
	return this._creative.getAdVolume();
};
//Passthrough for resizeAd
VPAIDWrapper.prototype.resizeAd = function (width, height, viewMode) {
	try {
		this._creative.resizeAd(width, height, viewMode);
	} catch (error) {
		console.warn(error);
	}
};
//Passthrough for pauseAd()
VPAIDWrapper.prototype.pauseAd = function () {
	this._pausedAfterClick = true;
	this._creative.pauseAd();
};
//Passthrough for resumeAd()
VPAIDWrapper.prototype.resumeAd = function () {
	this._pausedAfterClick = false;
	if (this._stopped) {
		this._mainCallback(MggpVendorVPAIDJSConsts.AdStopped);
	} else {
		this._creative.resumeAd();
	}
};
//Passthrough for expandAd()
VPAIDWrapper.prototype.expandAd = function () {
	this._creative.expandAd();
};
//Passthrough for collapseAd()
VPAIDWrapper.prototype.collapseAd = function () {
	this._creative.collapseAd();
};
// Pass through for getAdRemainingTime
VPAIDWrapper.prototype.getAdRemainingTime = function () {
	this._logFunc("getAdRemainingTime");
	return this._creative.getAdRemainingTime();
};
// Pass through for getAdDuration
VPAIDWrapper.prototype.getAdDuration = function () {
	this._logFunc("getAdRemainingTime");
	if (this._creative['getAdDuration']) return this._creative.getAdDuration();
	return null;
};
// Pass through for getAdExpanded
VPAIDWrapper.prototype.getAdExpanded = function () {
	this._logFunc("getAdExpanded");
	return this._creative.getAdExpanded();
};
// Pass through for getAdSkippableState
VPAIDWrapper.prototype.getAdSkippableState = function () {
	this._logFunc("getAdSkippableState");
	return this._creative.getAdSkippableState();
};

// Callback for AdLoaded
VPAIDWrapper.prototype.onAdLoaded = function () {
	this._logFunc("ad has been loaded");

	var volume = this._player.get('muted') || this._player.get('mutedAutoplay') ? 0 : this._player.get('volume') / 100;
	if (volume || volume === 0) {
		this.setAdVolume(volume);
	}

	this._mainCallback(MggpVendorVPAIDJSConsts.AdLoaded);
};
// Callback for StartAd()
VPAIDWrapper.prototype.onStartAd = function () {
	this._logFunc("Ad has started");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdStarted);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onStopAd = function () {
	if (!this._pausedAfterClick) {
		this._logFunc("Ad has stopped");
		this._mainCallback(MggpVendorVPAIDJSConsts.AdStopped);
		this._mainCallback = function () {};
	} else {
		this._stopped = true;
		this._mainCallback(MggpVendorVPAIDJSConsts.REMOVE_CREATIVE_AND_STAY_ON_PAUSE);
	}
};

// Callback for AdUserClose
VPAIDWrapper.prototype.onSkipAd = function () {
	this._logFunc("Ad was skipped");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdSkipped);
};
// Callback for AdPaused
VPAIDWrapper.prototype.onAdPaused = function () {
	this._paused = true;
	this._logFunc("onAdPaused");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdPaused);
};
// Callback for AdPlaying
VPAIDWrapper.prototype.onAdPlaying = function () {
	this._paused = false;
	this._logFunc("onAdPlaying");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdPlaying);
};
// Callback for AdError
VPAIDWrapper.prototype.onAdError = function (message) {
	this._logFunc("onAdError: " + message);
	this._mainCallback(MggpVendorVPAIDJSConsts.AdError);
};
// Callback for AdLog
VPAIDWrapper.prototype.onAdLog = function (message) {
	this._logFunc("onAdLog: " + message);
	this._mainCallback(MggpVendorVPAIDJSConsts.AdLog);
};
// Callback for AdUserAcceptInvitation
VPAIDWrapper.prototype.onAdUserAcceptInvitation = function () {
	this._logFunc("onAdUserAcceptInvitation");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdUserAcceptInvitation);
};
// Callback for AdUserMinimize
VPAIDWrapper.prototype.onAdUserMinimize = function () {
	this._logFunc("onAdUserMinimize");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdUserMinimize);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdUserClose = function () {
	this._logFunc("onAdUserClose");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdUserClose);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdSkippableStateChange = function () {
	this._logFunc("Ad Skippable State Changed to: " + this._creative.getAdSkippableState());
	this._mainCallback(MggpVendorVPAIDJSConsts.AdSkippableStateChange);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdExpandedChange = function () {
	this._logFunc("Ad Expanded Changed to: " + this._creative.getAdExpanded());
	this._mainCallback(MggpVendorVPAIDJSConsts.AdExpandedChange);
};
// Callback for AdSizeChange
VPAIDWrapper.prototype.onAdSizeChange = function () {
	this._logFunc("Ad size changed to: w=" + this._creative.getAdWidth() + " h=" + this._creative.getAdHeight());
	this._mainCallback(MggpVendorVPAIDJSConsts.AdSizeChange);
};
// Callback for AdDurationChange
VPAIDWrapper.prototype.onAdDurationChange = function () {
	var duration = this._creative.getAdDuration();
	this._logFunc("Ad Duration Changed to: " + duration);
	this._mainCallback(MggpVendorVPAIDJSConsts.AdDurationChange, duration);
};
// Callback for AdRemainingTimeChange
VPAIDWrapper.prototype.onAdRemainingTimeChange = function () {
	var time = this._creative.getAdRemainingTime();
	this._logFunc("Ad Remaining Time Changed to: " + time);
	this._mainCallback(MggpVendorVPAIDJSConsts.AdRemainingTimeChange, time);
};
// Callback for AdImpression
VPAIDWrapper.prototype.onAdImpression = function () {
	this._logFunc("Ad Impression");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdImpression);
};
// Callback for AdClickThru
VPAIDWrapper.prototype.onAdClickThru = function (url, id, playerHandles) {
	this._logFunc("Clickthrough portion of the ad was clicked");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdClickThru, { url: url, id: id, playerHandles: playerHandles });
};
// Callback for AdInteraction
VPAIDWrapper.prototype.onAdInteraction = function (id) {
	this._logFunc("A non-clickthrough event has occured");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdInteraction, { id: id });
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdVideoStart = function () {
	this._logFunc("Video 0% completed");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVideoStart);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdVideoFirstQuartile = function () {
	this._logFunc("Video 25% completed");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVideoFirstQuartile);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdVideoMidpoint = function () {
	this._logFunc("Video 50% completed");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVideoMidpoint);
};
// Callback for AdUserClose
VPAIDWrapper.prototype.onAdVideoThirdQuartile = function () {
	this._logFunc("Video 75% completed");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVideoThirdQuartile);
};
// Callback for AdVideoComplete
VPAIDWrapper.prototype.onAdVideoComplete = function () {
	this._logFunc("Video 100% completed");
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVideoComplete);
};
// Callback for AdLinearChange
VPAIDWrapper.prototype.onAdLinearChange = function () {
	this._logFunc("Ad linear has changed: " + this._creative.getAdLinear());
	this._mainCallback(MggpVendorVPAIDJSConsts.AdLinearChange);
};
// Callback for AdVolumeChange
VPAIDWrapper.prototype.onAdVolumeChange = function (event) {
	var adVolume = event && event.data || this._creative.getAdVolume();
	this._logFunc("Ad Volume has changed to - " + adVolume);

	var volume = adVolume * 100;
	if (!Number.isNaN(volume)) {
		this._player.set('volume', volume);
	}
	this._mainCallback(MggpVendorVPAIDJSConsts.AdVolumeChange);
};

module.exports = VPAIDWrapper;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});